(() => {
  'use strict';

  const drawerSelector = '#menu-drawer';
  const detailsSelector = '#Details-menu-drawer-container';
  const closeClass = 'gowin-menu-close';
  const hiddenClass = 'gowin-menu-widget-hidden';
  const staticHeaderStyleId = 'gowin-menu-static-header-behavior';
  const closePatchFlag = '__gowinFastMainClosePatched';
  const root = document.documentElement;

  let observer = null;
  let sweepQueued = false;

  const detailsElement = () => document.querySelector(detailsSelector);
  const summaryElement = () => document.querySelector(`${detailsSelector} > summary`);

  const patchMainCloseAnimation = (HeaderDrawer) => {
    if (!HeaderDrawer || HeaderDrawer.prototype[closePatchFlag]) return;

    const originalCloseAnimation = HeaderDrawer.prototype.closeAnimation;
    if (typeof originalCloseAnimation !== 'function') return;

    HeaderDrawer.prototype.closeAnimation = function (details) {
      if (!(details instanceof HTMLElement) || !details.matches(detailsSelector)) {
        return originalCloseAnimation.call(this, details);
      }

      const drawer = details.querySelector(drawerSelector);
      let finished = false;
      let fallbackTimer = 0;
      let onTransitionEnd = null;

      const finish = () => {
        if (finished) return;
        finished = true;
        if (drawer && onTransitionEnd) drawer.removeEventListener('transitionend', onTransitionEnd);
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        details.removeAttribute('open');
      };

      onTransitionEnd = (event) => {
        if (event.target !== drawer || event.propertyName !== 'transform') return;
        finish();
      };

      if (drawer) drawer.addEventListener('transitionend', onTransitionEnd);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !drawer) {
        window.requestAnimationFrame(finish);
        return;
      }

      fallbackTimer = window.setTimeout(finish, 280);
    };

    Object.defineProperty(HeaderDrawer.prototype, closePatchFlag, {
      value: true,
      configurable: false,
      enumerable: false,
      writable: false,
    });
  };

  const ensureMainClosePatch = () => {
    const HeaderDrawer = customElements.get('header-drawer');
    if (HeaderDrawer) {
      patchMainCloseAnimation(HeaderDrawer);
      return;
    }

    customElements.whenDefined('header-drawer').then(() => {
      patchMainCloseAnimation(customElements.get('header-drawer'));
    });
  };

  const ensureStaticHeaderStyles = () => {
    if (document.getElementById(staticHeaderStyleId)) return;

    const style = document.createElement('style');
    style.id = staticHeaderStyleId;
    style.textContent = `
      @media screen and (max-width: 989px) {
        #menu-drawer.menu-drawer {
          transition:
            transform 220ms cubic-bezier(.22, 1, .36, 1),
            visibility 0s linear !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) header-drawer,
        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .menu-drawer-container {
          position: relative !important;
          z-index: 40 !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) #menu-drawer.menu-drawer {
          z-index: 41 !important;
          isolation: isolate !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__icons,
        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .gowin-mobile-search,
        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) #cart-icon-bubble {
          position: relative !important;
          z-index: 0 !important;
          pointer-events: none !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header-wrapper {
          width: 100% !important;
          height: auto !important;
          min-height: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          border-bottom: 1px solid rgba(16, 26, 43, .08) !important;
          background: rgba(255, 255, 255, .94) !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header {
          width: 100% !important;
          height: 5.4rem !important;
          min-height: 5.4rem !important;
          margin: 0 !important;
          padding: .5rem 1rem !important;
          border: 0 !important;
          background: transparent !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__heading {
          display: block !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__heading-link {
          display: inline-flex !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .header > .header__icons {
          display: flex !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) header-drawer {
          position: static !important;
          display: block !important;
          width: auto !important;
          height: auto !important;
          margin: 0 !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .menu-drawer-container {
          position: static !important;
          display: flex !important;
          width: auto !important;
          height: auto !important;
          margin: 0 !important;
        }

        html.gowin-menu-open body:has(#Details-menu-drawer-container[open]) .gowin-mobile-search {
          visibility: visible !important;
          opacity: 1 !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu {
          position: static !important;
          z-index: auto !important;
          display: grid !important;
          place-items: center !important;
          width: 4.4rem !important;
          min-width: 4.4rem !important;
          height: 4.4rem !important;
          min-height: 4.4rem !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          opacity: 1 !important;
          pointer-events: auto !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu > span {
          display: inline-flex !important;
          width: auto !important;
          height: auto !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu svg {
          display: block !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu .icon-hamburger {
          visibility: visible !important;
          opacity: 1 !important;
          transform: none !important;
        }

        #Details-menu-drawer-container[open] > summary.header__icon--menu .icon-close {
          visibility: hidden !important;
          opacity: 0 !important;
          transform: none !important;
        }

        html.gowin-menu-open .section-header,
        html.gowin-menu-open .section-header .header-wrapper,
        html.gowin-menu-open .section-header .header,
        html.gowin-menu-open .section-header .header__heading,
        html.gowin-menu-open .section-header .header__heading-link,
        html.gowin-menu-open .section-header .header__heading-logo-wrapper,
        html.gowin-menu-open .section-header .header__heading-logo,
        html.gowin-menu-open .section-header .header__icons,
        html.gowin-menu-open .section-header .header__icon,
        html.gowin-menu-closing .section-header,
        html.gowin-header-returning .section-header,
        html.gowin-header-returning .section-header .header__heading-logo,
        html.gowin-header-returning .section-header .header__icon {
          animation: none !important;
          transition: none !important;
        }

        html.gowin-menu-closing .section-header,
        html.gowin-header-returning .section-header {
          opacity: 1 !important;
          visibility: visible !important;
          transform: none !important;
          pointer-events: auto !important;
        }
      }
    `;

    (document.head || document.documentElement).appendChild(style);
  };

  const resetMenuPosition = () => {
    const details = detailsElement();
    const drawer = document.querySelector(drawerSelector);
    if (!details || !drawer) return;

    details.querySelectorAll('details').forEach((nestedDetails) => {
      nestedDetails.removeAttribute('open');
      nestedDetails.classList.remove('menu-opening', 'submenu-open');

      const nestedSummary = nestedDetails.querySelector(':scope > summary');
      nestedSummary?.setAttribute('aria-expanded', 'false');
    });

    drawer.querySelectorAll('.submenu-open, .menu-opening').forEach((element) => {
      element.classList.remove('submenu-open', 'menu-opening');
    });

    const scrollableElements = [
      drawer,
      ...drawer.querySelectorAll(
        '.menu-drawer__navigation-container,' +
          '.menu-drawer__navigation,' +
          '.menu-drawer__inner-container,' +
          '.menu-drawer__submenu,' +
          '.menu-drawer__inner-submenu'
      ),
    ];

    scrollableElements.forEach((element) => {
      element.scrollTop = 0;
      element.scrollLeft = 0;
    });
  };

  const closeMenu = () => {
    const summary = summaryElement();
    if (summary instanceof HTMLElement) summary.click();
  };

  const ensureCloseButton = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer || drawer.querySelector(`.${closeClass}`)) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = closeClass;
    button.setAttribute('aria-label', 'Cerrar menú');

    const glyph = document.createElement('span');
    glyph.setAttribute('aria-hidden', 'true');
    button.append(glyph);
    button.addEventListener('click', closeMenu);
    drawer.append(button);
  };

  const likelyFloatingWidget = (element) => {
    if (!(element instanceof HTMLElement) || element.closest(drawerSelector)) return false;
    const style = getComputedStyle(element);
    if (style.position !== 'fixed') return false;
    const rect = element.getBoundingClientRect();
    return (
      window.innerWidth - rect.right <= 56 &&
      window.innerHeight - rect.bottom <= 250 &&
      rect.width >= 38 &&
      rect.width <= 150 &&
      rect.height >= 38 &&
      rect.height <= 150
    );
  };

  const candidates = () => {
    const explicit = document.querySelectorAll(
      "[id*='whatsapp' i],[class*='whatsapp' i],a[href*='wa.me' i],a[href*='api.whatsapp.com' i],a[href*='whatsapp.com' i],iframe[src*='whatsapp' i],#shopify-chat,[data-shopify-chat]"
    );
    const compactFixed = Array.from(document.body.querySelectorAll('*')).filter(likelyFloatingWidget);
    return [...new Set([...explicit, ...compactFixed])];
  };

  const hideWidgets = () => {
    candidates().forEach((node) => {
      const wrapper =
        node.closest("[id*='whatsapp' i],[class*='whatsapp' i],[data-shopify-chat]") || node;
      if (!wrapper.closest(drawerSelector)) wrapper.classList.add(hiddenClass);
    });
  };

  const restoreWidgets = () => {
    document.querySelectorAll(`.${hiddenClass}`).forEach((node) => {
      node.classList.remove(hiddenClass);
    });
  };

  const queueSweep = () => {
    if (sweepQueued) return;
    sweepQueued = true;
    requestAnimationFrame(() => {
      sweepQueued = false;
      if (root.classList.contains('gowin-menu-open')) hideWidgets();
    });
  };

  const startObserver = () => {
    if (observer || !document.body) return;
    observer = new MutationObserver(queueSweep);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const stopObserver = () => {
    observer?.disconnect();
    observer = null;
  };

  const beginOpen = () => {
    root.classList.remove('gowin-menu-closing', 'gowin-header-returning');
    resetMenuPosition();
    root.classList.add('gowin-menu-open');
    hideWidgets();
    startObserver();
    queueSweep();
    requestAnimationFrame(resetMenuPosition);
  };

  const finishClose = () => {
    stopObserver();
    root.classList.remove('gowin-menu-open', 'gowin-menu-closing', 'gowin-header-returning');
    resetMenuPosition();
    restoreWidgets();
  };

  const bindState = () => {
    const details = detailsElement();
    const summary = summaryElement();
    if (!details || !summary || details.dataset.gowinPolishBound === 'true') return;
    details.dataset.gowinPolishBound = 'true';

    summary.addEventListener(
      'click',
      () => {
        if (!details.hasAttribute('open')) resetMenuPosition();
      },
      true
    );

    const sync = () => {
      details.hasAttribute('open') ? beginOpen() : finishClose();
    };

    details.addEventListener('toggle', sync);
    sync();
  };

  const run = () => {
    ensureStaticHeaderStyles();
    ensureMainClosePatch();
    root.classList.remove('gowin-menu-closing', 'gowin-header-returning');
    ensureCloseButton();
    bindState();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run, { once: true })
    : run();

  document.addEventListener('shopify:section:load', run);
  window.addEventListener('pageshow', run);
})();
